import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

export const Logout = () => {
    const { logout } = useAuth();

    useEffect(() => {
        logout();
    }, [logout]);

    return (<div></div>);
}
